import React, { useEffect, useState } from "react";
import { Link as ReactLink } from 'react-router-dom';
import { Table, Tbody, Tr, TableContainer, Td, Link, Box, Flex, Stack, InputGroup, InputRightElement, Input, Divider, AbsoluteCenter, Text } from "@chakra-ui/react";
import { SearchIcon } from "../../components/stations/assets/search-icon";
import useDatasetsMetadata from "../../components/customHooks/useDatasetsMetadata";
import { getStationName, filterTidalBuoys } from "../../utils/helpers";
import Loading from "../../components/Loading";
import { RegionFilterDrawer } from "../../components/regionFilterDrawer/RegionFilterDrawer";
import { SelectedRegionBar } from "../../components/regionFilterDrawer/SelectedRegionBar";
import useRegions from "../../components/customHooks/useRegions";

export const StationIndex = () => {
    const datasetsMetadata = useDatasetsMetadata();
    const regions = useRegions();
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedRegions, setSelectedRegions] = useState([]);

    const [stations, setStations] = useState(filterTidalBuoys(datasetsMetadata.data));

    const resetStations = () => {
        setStations(filterTidalBuoys(datasetsMetadata.data));
    };

    useEffect(() => {
        resetStations();
    }, [datasetsMetadata.data]);

    const handleSearchInputChange = (event) => {
        const query = event.target.value;
        setSearchTerm(query);

        if (query) {
            const filteredStations = filterTidalBuoys(datasetsMetadata.data)
                .filter((station) =>
                    getStationName(station?.metadata)
                        .toLowerCase()
                        .includes(
                            query.toLowerCase()
                        )
                )
                .filter((station) => {
                    if (selectedRegions?.length > 0) {
                        return selectedRegions.includes(station?.regionID);
                    } else {
                        return true;
                    }
                });
            setStations(filteredStations);
        } else {
            setStations(
                filterTidalBuoys(datasetsMetadata.data)
                    .filter((station) => {
                        if (selectedRegions?.length > 0) {
                            return selectedRegions.includes(station?.regionID);
                        } else {
                            return true;
                        }
                })
            );
        }
    };

    useEffect(() => {
        setSearchTerm('');
        if (selectedRegions?.length > 0) {
            const regionStations = filterTidalBuoys(datasetsMetadata.data).filter((station) => {
                return selectedRegions.includes(station?.regionID);
            });
            setStations(regionStations);
        } else {
            resetStations();
        }
    }, [selectedRegions, datasetsMetadata.data]);

    return (
        <Box bg='white' pb={8} pt={1}>
            <Box px={4}>
                <Flex justifyContent={'space-between'} alignItems={'center'}>
                    <Text fontSize={'20px'} fontWeight={'bold'} marginY={5}>Stations</Text>
                    <RegionFilterDrawer regions={regions.data?.regions} selectedRegions={selectedRegions} setSelectedRegions={setSelectedRegions} />
                </Flex>
                <SelectedRegionBar regions={regions.data?.regions} selectedRegions={selectedRegions} setSelectedRegions={setSelectedRegions} />
                <Stack spacing={4}>
                    <InputGroup>
                        <InputRightElement pointerEvents='none' backgroundColor={'gray.100'} borderRightRadius={8} border={'1px rgb(203, 213, 224) solid'}>
                            <SearchIcon color='gray.300' />
                        </InputRightElement>
                        <Input type='search' placeholder='Search Stations...' value={searchTerm} onChange={handleSearchInputChange} />
                    </InputGroup>
                </Stack>
                <Box position='relative' paddingTop='10' paddingBottom='10'>
                    <Divider />
                    <AbsoluteCenter bg='white' px='4' textColor={'gray.400'} marginBottom={20}>All Stations</AbsoluteCenter>
                </Box>
            </Box>
            {datasetsMetadata.isLoading && <Loading />}
            <TableContainer px={4}>
                <Table variant="simple">
                    <Tbody>
                        {stations?.map((station, index) => (
                            <Tr key={index}>
                                <Td style={{ textWrap: 'wrap' }} px={0}>
                                    <Link textColor={'teal.700'} as={ReactLink} to={`/stations/${station?.datasetID}`} fontSize='md'>
                                        {getStationName(station?.metadata)}
                                    </Link>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    );
};
